<template>
  <v-dialog
    scrollable
    v-model="visable"
    max-width="600px"
    :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">
        {{ loading ? '正在提交…' : '确认提交？' }}
      </v-card-title>

      <v-divider></v-divider>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <p class="subheading">{{ message }}</p>
        <v-divider/>
        <div>
          <v-textarea
            label="备注信息"
            counter="200"
            v-model="note"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="onCancel">取消</v-btn>
        <v-btn color="primary" :disabled="loading" @click.native="onSubmit">提交</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  model: {
    prop: 'visable',
    event: 'input'
  },

  props: ['visable', 'message', 'uri', 'dbid', 'data'],

  data() {
    return {
      loading: false,
      note: ''
    }
  },

  methods: {
    onCancel(){
      this.$emit('cancel',{})
      this.$emit('input', false)
      this.note = ''
    },
    onSubmit() {
      const vm = this;
      this.loading = true;
      const data = {
        "message": this.note,
        "formJson": this.data
      };
      console.log(data)

      this.axios.put(`${this.uri}/${this.dbid}`, data)
        .then(rsp => {
          vm.$emit('ok', rsp.data);
          vm.$emit('input', false);
          vm.loading = false;
          vm.note = ''
        });
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/global/wf/Submit.vue